module.exports = __webpack_public_path__ + "static/media/61s90CJzEzL._SL1200_.65c1f93e.jpg";